import { render, staticRenderFns } from "./OSD.vue?vue&type=template&id=07e895a8&scoped=true&"
import script from "./OSD.vue?vue&type=script&lang=js&"
export * from "./OSD.vue?vue&type=script&lang=js&"
import style0 from "./OSD.vue?vue&type=style&index=0&id=07e895a8&scoped=true&lang=css&"
import style1 from "./OSD.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e895a8",
  null
  
)

export default component.exports